import { useCallback, useState } from 'react';
import { useApi } from './useApi';

// A GRC control's evidence PDF (Security Insights "Download PDF"), for every page that offers it.
// isDownloading(controlId): that control's download is running (its button shows "Downloading…").
export const useEvidenceDownload = () => {
    const apiCall = useApi();
    const [downloadingIds, setDownloadingIds] = useState(() => new Set());

    const downloadEvidence = useCallback(async (controlId) => {
        if (downloadingIds.has(controlId)) return;
        setDownloadingIds(prev => new Set(prev).add(controlId));
        try {
            const blob = await apiCall('GET', `/security-insights/evidence/${encodeURIComponent(controlId)}/file`, null, false, 'blob');
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `evidence-${controlId}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch {
            alert('Failed to download evidence file. Please try again.');
        } finally {
            setDownloadingIds(prev => { const s = new Set(prev); s.delete(controlId); return s; });
        }
    }, [apiCall, downloadingIds]);

    const isDownloading = useCallback((controlId) => downloadingIds.has(controlId), [downloadingIds]);
    return { downloadEvidence, isDownloading };
};
